import { createSlice } from "@reduxjs/toolkit";

const initialState = JSON.parse(localStorage.getItem("formData")) || {};

const formSlice = createSlice({
    name: "form",
    initialState,
    reducers: {
      saveFormData: (state, action) => {
        const { sectionId, data } = action.payload;
        const newState = {
          ...state,
          [sectionId]: { ...state[sectionId], ...data },
        };
        localStorage.setItem("formData", JSON.stringify(newState));
        return newState;
      },
      loadFormData: (state, action) => {
        return { ...action.payload };
      },
    },
  });
  

export const { saveFormData, loadFormData } = formSlice.actions;
export default formSlice.reducer;
